import React, { useState } from "react";
import FadeInSection from "../../../Components/FadeInSection";

const DashboardFAQEdit = ({ data, onClose, onSave }) => {
  const [question, setQuestion] = useState(data.question || "");
  const [answer, setAnswer] = useState(data.answer || "");
  const [status, setStatus] = useState(data.status || 0);

  const handleSave = () => {
    const updatedData = {
      ...data,
      question,
      answer,
      status,
    };
    onSave(updatedData);
  };

  return (
<div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[9999]">
      <div className="w-[0vw] md:w-1/6"></div>
      <div
          className={`bg-white p-6 rounded shadow-lg w-full h-full flex flex-col overflow-auto`}
        >
          <h2 className="text-lg font-semibold text-gray-800 mb-4">Edit FAQ</h2>
          <div className="border-t border-gray-200 mb-6"></div>
          <div className="flex flex-col space-y-8 flex-grow">
            {/* Flex layout for headers and inputs */}
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">
                Question
              </p>
              <textarea
                className="w-2/3 border rounded p-2 text-gray-800"
                rows="3"
                value={question}
                onChange={(e) => setQuestion(e.target.value)}
              />
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Answer</p>
              <textarea
                className="w-2/3 border rounded p-2 text-gray-800"
                rows="5"
                value={answer}
                onChange={(e) => setAnswer(e.target.value)}
              />
            </div>
            <div className="flex">
              <p className="text-sm font-medium text-gray-500 w-1/3">Status</p>
              <select
                className="w-2/3 border rounded p-2 text-gray-800"
                value={status}
                onChange={(e) => setStatus(Number(e.target.value))}
              >
                <option value={1}>Active</option>
                <option value={2}>Inactive</option>
              </select>
            </div>
          </div>
          <div className="mt-6 flex justify-start space-x-4">
            <button
              className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className="px-4 py-2 bg-blue-500 text-white rounded-lg"
              onClick={handleSave}
            >
              Save Changes
            </button>
          </div>
        </div>
      {/* </FadeInSection> */}
    </div>
  );
};

export default DashboardFAQEdit;
